import type { CSSProperties } from "react";

export const DEFAULT_DURATION = { faster: 0.1, medium: 0.2, slower: 0.3 };
export const MOTION_DEFAULTS = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 10 },
    transition: { duration: DEFAULT_DURATION.medium, ease: "easeOut" }
};
export const DEFAULT_CHILD_ANIMATION_DELAY = 450; // milliseconds

export function canvasHoverProps(visible: boolean, options?: { pointerEvents?: "auto" | "none" }) {
    const pointerEvents = options?.pointerEvents ?? (visible ? "auto" : "none");
    return {
        initial: false as const,
        animate: { opacity: visible ? 1 : 0 },
        transition: { duration: 0 },
        style: { pointerEvents: pointerEvents as CSSProperties["pointerEvents"] }
    };
}
